module.exports = __webpack_public_path__ + "static/img/14000130.fd5cff04.png";